import { render, staticRenderFns } from "./OrganizationLinkedDomainsList.vue?vue&type=template&id=84df006c&scoped=true"
import script from "./OrganizationLinkedDomainsList.vue?vue&type=script&lang=js"
export * from "./OrganizationLinkedDomainsList.vue?vue&type=script&lang=js"
import style0 from "./OrganizationLinkedDomainsList.vue?vue&type=style&index=0&id=84df006c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84df006c",
  null
  
)

export default component.exports